import React from "react";

import ModalAddUserHeader from "../header/header";
import ModalAddUserCompanyUsers from "../company-users/company-users";
import ModalAddUserNewUser from "../new-user/new-user";
import ModalAddUserSubmit from "../submit/submit";

import Classes from "classnames";

export default function ModalAddUserCommonUsersForm(props) {

    const stopPropagation = (e) => {
        e.stopPropagation();
        e.preventDefault();
    }

    const search =  props.search ? props.search.trim().toLowerCase() : false;

    // init company users
    let companyUsers = [];
    // only regular users and company managers can see company users
    if (gd.ac.check.company.canSeeCompanyUsers()) {
        if (search) {
            props.companyUsers.map(cu => {
                if (cu.user.name.toLowerCase().includes(search) === true) companyUsers.push(cu);
            });
        } else {
            companyUsers = props.companyUsers;
        }
    }

    const mainClasses = Classes('main',{
        multiselect: props.multiselect
    });

    // 'add-user'
    const modalClasses = Classes('v4-container', 'placement-middle',{
        multiselect: props.multiselect
    });

    return (
        <div className={modalClasses} onClick={stopPropagation}>
            <ModalAddUserHeader search={props.search}
                                onSearchChange={props.onSearchChange}
                                onSearchCancel={props.onSearchCancel}
                                closeModal={props.closeModal}/>

            <div className={mainClasses}>
                {companyUsers && <div className="group-name m-b-20">Company users</div>}
                <ModalAddUserCompanyUsers companyUsers      = {companyUsers}
                                          selected          = {props.selected}
                                          multiselect       = {props.multiselect}
                                          mode              = {props.mode}
                                          showDepartments   = {props.showDepartments}
                                          accessLevels      = {props.accessLevels}
                                          projectId         = {props.projectId}
                                          onAccessSelect    = {props.onAccessSelect}
                                          onUserClick       = {props.onUserClick}/>
                <ModalAddUserNewUser />
                {!companyUsers && <div className="not-found">No users found</div>}
            </div>

            <ModalAddUserSubmit mode={props.mode}
                                multiselect={props.multiselect}
                                canSubmit={props.canSubmit}
                                onClickSubmit={props.onClickSubmit}/>
        </div>
    );
}